// Couleurs des 4 applications SCADA pour les barres du Gantt.
export const APP_COLORS = {
  reservoir: '#2f9e6e',
  barriere: '#f2994a',
  feu_tricolore: '#eb5757',
  surveillance: '#5b6bde',
};

export const getAppColor = (application) => APP_COLORS[application] || '#8895a7';